export default "__VITE_ASSET__BB77ACpM__"